import { render } from "./Emails.vue?vue&type=template&id=bc0f9d46&scoped=true"
import script from "./Emails.vue?vue&type=script&lang=js"
export * from "./Emails.vue?vue&type=script&lang=js"

import "./Emails.vue?vue&type=style&index=0&id=bc0f9d46&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc0f9d46"]])

export default __exports__